module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"selec_reves":"Se debe seleccionar el revestimiento existente para poder añadir el proceso constructivo."}}')
  delete Component.options._Ctor
}
